export { ScoreRing, type ScoreRingProps } from './ScoreRing'
